var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('full-text-url-provider',{attrs:{"reference-id":_vm.reference.id},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var url = ref.url;
return [(url)?_c('pdf-document',{attrs:{"src":url,"height":_vm.height}}):_c('div',{staticClass:"loader d-flex justify-center align-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }